import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=a04b56f4&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04b56f4')) {
      api.createRecord('a04b56f4', component.options)
    } else {
      api.reload('a04b56f4', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=a04b56f4&", function () {
      api.rerender('a04b56f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25526uOI11vNK/JS/imageCarousel.vue"
export default component.exports